module.exports = "<template> <span class.bind=getClass()>${ value | date:'L'} <template if.bind=item.delay> (+${item.delay})</template></span> </template> ";